// extracted by mini-css-extract-plugin
module.exports = {"form-label":"form-label-W4J1GR_","input-wrapper":"input-wrapper-LQlsRqY"};